cv.PublicDonorsRowEmptyView = Marionette.LayoutView.extend({
  className: 'donor-empty',
  template: cv.Templates['public/donors/donors_row_empty'],

  events : {
  },

  templateHelpers: function(){
    return {
      is_team : this.options.page_type == 'team',
      is_project : this.options.page_type == 'project',
      is_campaign : this.options.page_type == 'campaign'
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log(this.options);
    console.log('PublicDonorsRowEmptyView initialized');
  },

  onAttach: function(){
    var url = top.location.toString();
    this.$('.cv-donate').attr('data-url', url.split('//')[1]);
  }
});
